import { ReactNode } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { StorageNoticeBar } from '../legal/StorageNoticeBar'
import { WalletStatusBar } from '../wallet/WalletStatusBar'
import CosignCeremonyOverlay from '../wallet/CosignCeremonyOverlay'

interface LayoutProps {
	children: ReactNode
}

export function Layout({ children }: LayoutProps) {
	return (
		<div className="min-h-screen bg-background">
			<Header />
			<main className="flex-1">
				{children}
			</main>
			<Footer />
			{/* Both bars dock to the bottom. The notice (z-40) yields to the
			    wallet status bar (z-50) whenever a scan/send is in flight. */}
			<StorageNoticeBar />
			<WalletStatusBar />
			{/* App-wide co-signing pairing QR + status (z-90), shown only while a
			    co-signed payment is in flight. */}
			<CosignCeremonyOverlay />
		</div>
	)
} 